import { Component, OnInit, Input } from '@angular/core';
import { SummaryConfig, QuestionKind } from '../../../../common/models/flow.dto';

@Component({
    selector: 'summary-config-item',
    templateUrl: './summary-config-item.component.html',
    styleUrls: ['./summary-config-item.component.scss'],
    standalone: false
})
export class SummaryConfigItemComponent implements OnInit {
    visible: boolean = false;
    @Input()
    item: Item; 

    constructor() { }
     
    ngOnInit() {
    }
}

type Item = {
    contextValue: string,
    isDisplayed: boolean,
    questionDomain: string,
    questionKey: string,
    questionLabel: string,
    summaryDisplay: string,
    type: QuestionKind,
    validationRules: any[]
}
